


























import { Vue, Component } from 'vue-property-decorator'
import { Action, State, Getter } from 'vuex-class'

import ScrollTopButton from '@/components/ScrollTopButton.vue'
import NetatmoHeader from '@/components/NetatmoHeader.vue'
import Contentloader from '@/components/Contentloader.vue'
import BannerIntro from '@/components/BannerIntro.vue'
import Dropdown from '@/components/Dropdown.vue'
import TableOfContent from '@/components/TableOfContent.vue'
import CookieConsentCgu from '@/components/CookieConsentCgu.vue'
import ShouldAcceptButton from '@/components/ShouldAcceptButton.vue'

import { ObjectItem } from '../store/types'

@Component({
  components: {
    NetatmoHeader,
    Contentloader,
    BannerIntro,
    TableOfContent,
    Dropdown,
    ScrollTopButton,
    ShouldAcceptButton
  }
})
export default class NetatmoLayout extends Vue {
  @State(state => state.CONTENT.iframe) iframe!: boolean
  @State(state => state.CONTENT.selectedLanguage) currentLang!: string
  @State(state => state.CONTENT.languages) languages!: ObjectItem[]

  @Action('CONTENT/loadContent') loadContent!: () => void

  @Getter('CONTENT/isMultiLang') isMultiLang!: boolean
  @Getter('CONTENT/currentLangObject') currentLangObject!: ObjectItem

  changeLang (value: ObjectItem) {
    window.location.pathname = window.location.pathname.replace(this.currentLang, value.key)
  }

  loading = false

  scrollTop () {
    this.$nextTick(() => {
      (this.$refs.content as Vue & { scrollTop: number }).scrollTop = 0
    })
  }

  async mounted () {
    this.loading = true
    await this.loadContent()
    this.loading = false
    this.$nextTick(() => {
      this.$store.commit('CONTENT/SET_LOADED', true)
      const MyComponent = Vue.extend(CookieConsentCgu)
      const instance = new MyComponent({
        store: this.$store,
        propsData: { isCGU: true }
      })
      instance.$mount()
      const element: HTMLElement = instance.$el as HTMLElement
      const cookieModal = document.getElementById('cookie-modal')
      if (cookieModal) {
        cookieModal.replaceWith(element)
      }
    })
  }
}
